import {createRouter, createWebHistory} from 'vue-router'
import Store from "@/Store"
import Home from "@/Pages/Home"
import Courses from "@/Pages/Courses"
import Course from "@/Pages/Course"
import AdminDashboard from "@/Pages/Admin/Dashboard"
import Auth from "@/Router/Routes/Auth"
import AdminUsers from "@/Router/Routes/Admin/Users"
import AdminPathways from "@/Router/Routes/Admin/Pathways";
import AdminCourses from "@/Router/Routes/Admin/Courses";
import AdminCourseSessionGroups from "@/Router/Routes/Admin/CourseSessionGroups";
import AdminCourseApplications from "@/Router/Routes/Admin/CourseApplications";
import AdminCourseRecords from "@/Router/Routes/Admin/CourseRecords";
import AdminUserAwards from "@/Router/Routes/Admin/UserAwards";
import AdminAssignment from "@/Router/Routes/Admin/Assignment";
import AdminSettings from "@/Router/Routes/Admin/Settings";
import Students from "@/Router/Routes/Students";

const router = createRouter({
    history: createWebHistory(),
    scrollBehavior: (to, from, savedPosition) => {

        const el = document.querySelector('#app > div')

        if (savedPosition) {
            return {el, top: savedPosition.top};
        } else if (to.hash) {
            return {el: to.hash};
        }

        return {el, top: 0};
    },
    routes: [
        {
            path: '/',
            component: Home,
            name: 'home',
        },
        {
            path: '/courses',
            component: Courses,
            name: 'courses',
        },
        {
            path: '/courses/:courseId',
            component: Course,
            name: 'course',
        },
        {
            path: '/profile',
            component: require('@/Pages/Profile/Show').default,
            name: 'profile',
            meta: {
                auth: true
            },
        },
        {
            path: '/admin',
            component: AdminDashboard,
            name: 'admin',
            meta: {
                auth: true
            },
        },
        ...Auth,
        ...Students,
        ...AdminUsers,
        ...AdminPathways,
        ...AdminCourses,
        ...AdminCourseSessionGroups,
        ...AdminCourseApplications,
        ...AdminCourseRecords,
        ...AdminUserAwards,
        ...AdminSettings,
        ...AdminAssignment,
    ]
});


router.beforeEach((to, from, next) => {
    if (to.meta.guest && Store.getters.authenticated) {
        next({name: 'home'});
    } else if (to.meta.auth && !Store.getters.authenticated) {
        Store.commit('SET_INTENDED', to);
        next({name: 'login'})
    } else {
        next();
    }
});

router.afterEach((to, from) => {
    to.meta.previous = from.matched.length ? from.path : null;
});

export default router;
